import axios, { InternalAxiosRequestConfig } from 'axios';
import { EXTENDED_API_TIMEOUT } from '../../APIConstants';
import {
  applyAGraphResponseTransformations,
  getAGraphBaseUrl,
  getApiBaseUrlSuffix,
  modifyAGraphURL,
  ResponseTransformConfig,
  setAGraphHeaders,
} from '../../utils';
import { AGraphApiSettings } from '../Base';
import { conditionalParam, isAGraphEnabled } from './AGraphUtils';
import { ALADDIN_PORTFOLIO_BUILDER_API_URL, ALADDIN_PORTFOLIO_BUILDER_API_URL_AGRAPH } from './Constants';

interface Settings extends AGraphApiSettings {
  getPkgFn?: () => string | undefined;
}

export const apbSettings: Settings = {};
export const apbApi = axios.create();

apbApi.interceptors.request.use((config) => {
  const { getPkgFn, getConfigurationDirectoryFn, getAladdinApiKey, getEnvTypeFn } = apbSettings;
  const configurationDirectory = getConfigurationDirectoryFn?.();
  const envType = getEnvTypeFn?.();
  const enableAGraph = isAGraphEnabled();
  const baseURL = enableAGraph
    ? getAGraphBaseUrl(ALADDIN_PORTFOLIO_BUILDER_API_URL_AGRAPH)
    : ALADDIN_PORTFOLIO_BUILDER_API_URL + getApiBaseUrlSuffix(envType, '_', true);
  const pkg = config.params?.pkg ?? getPkgFn?.();

  if (!pkg) {
    throw Error('You must define a function for apbSettings.getPkgFn before using apbApi');
  }

  const updatedConfig: InternalAxiosRequestConfig = {
    ...config,
    baseURL,
    timeout: EXTENDED_API_TIMEOUT,
    params: {
      ...config.params,
      pkg: conditionalParam(config.url, 'pkg', pkg),
      configurationDirectory: conditionalParam(config.url, 'configurationDirectory', configurationDirectory),
    },
  };

  setAGraphHeaders(updatedConfig, getAladdinApiKey?.(), envType);
  if (enableAGraph) {
    modifyAGraphURL(updatedConfig, ['/api/v3', 'api/v3', 'api/v4', 'api/v7']);
  }
  return updatedConfig;
});

// Apply response transformations for AGraph API
apbApi.interceptors.response.use((response) => {
  if (isAGraphEnabled() && response.data) {
    const AGRAPH_RESPONSE_TRANSFORMS: ResponseTransformConfig[] = [
      {
        urlPattern: '/securities{,/_resolve,/live}',
        timestampFields: ['lastUpdatedTime'],
      },
      {
        urlPattern: '/securities/_search',
        method: 'POST',
        timestampFields: ['lastUpdatedTime'],
      },
    ];
    applyAGraphResponseTransformations(response, AGRAPH_RESPONSE_TRANSFORMS);
  }

  return response;
});
